/* AliyDesign – theme scripts */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* ------------------------------------------------------------------
     Drawers (menu, zoeken, winkelwagen, filters, maattabel)
  ------------------------------------------------------------------ */
  var overlay = $('[data-overlay]');
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    closeDrawers(true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.documentElement.classList.add('no-scroll');
    setTimeout(function () {
      var focusTarget = drawer.querySelector('input[type="search"]') || drawer.querySelector('button, a, input');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 60);
    if (drawer.id === 'cart-drawer') loadCartRecommendations();
  }

  function closeDrawers(keepFocus) {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var drawer = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (drawer) {
        e.preventDefault();
        openDrawer(drawer);
      }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      e.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ------------------------------------------------------------------
     Header: schaduw bij scrollen
  ------------------------------------------------------------------ */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------
     Aankondigingsbalk
  ------------------------------------------------------------------ */
  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var index = 0;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 5000);
  });

  /* ------------------------------------------------------------------
     Zoeksuggesties
  ------------------------------------------------------------------ */
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults && theme.routes.predictiveSearch) {
    var searchTimer = null;
    var searchController = null;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        if (searchController) searchController.abort();
        searchController = 'AbortController' in window ? new AbortController() : null;
        var url = theme.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,page' +
          '&resources[limit]=8' +
          '&resources[options][fields]=title,product_type,variants.title,vendor';
        fetch(url, searchController ? { signal: searchController.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var inner = parseHTML(html).querySelector('[data-predictive-inner]');
            searchResults.innerHTML = inner ? inner.outerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ------------------------------------------------------------------
     Winkelwagen
  ------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = String(count) === '0';
    });
  }

  function renderCartDrawer(sections) {
    var html = sections && sections['cart-drawer'];
    var promise = html
      ? Promise.resolve(html)
      : fetch((theme.routes.root || '/') + '?section_id=cart-drawer').then(function (r) { return r.text(); });

    return promise.then(function (markup) {
      var fresh = parseHTML(markup).querySelector('[data-cart-inner]');
      var current = $('[data-cart-inner]');
      if (fresh && current) {
        current.replaceWith(fresh);
        updateCartCount(fresh.getAttribute('data-count'));
      }
      loadedRecsUrl = null;
      if ($('#cart-drawer.is-open')) loadCartRecommendations();
    });
  }

  function addToCart(formData) {
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || theme.strings.cartError);
        }
        if (theme.cartType === 'page') {
          window.location.href = theme.routes.cart;
          return;
        }
        return renderCartDrawer(res.data.sections).then(function () {
          openDrawer($('#cart-drawer'));
        });
      });
  }

  function changeCart(line, quantity) {
    var inner = $('[data-cart-inner]');
    if (inner) inner.classList.add('is-updating');
    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || theme.strings.cartError);
        return renderCartDrawer(data.sections);
      })
      .catch(function (err) {
        if (inner) inner.classList.remove('is-updating');
        window.alert(err.message || theme.strings.cartError);
      });
  }

  // Productformulier
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"][name="add"]');
    var error = form.querySelector('[data-form-error]');
    if (error) error.textContent = '';
    if (button) button.classList.add('is-loading');

    addToCart(new FormData(form))
      .catch(function (err) {
        if (error) error.textContent = err.message;
        else window.alert(err.message);
      })
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  });

  // Snel toevoegen vanaf productkaart en wijzigen in winkelwagen
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      if (quick.disabled) return;
      var fd = new FormData();
      fd.append('id', quick.getAttribute('data-variant-id'));
      fd.append('quantity', '1');
      quick.classList.add('is-loading');
      addToCart(fd)
        .catch(function (err) { window.alert(err.message); })
        .then(function () { quick.classList.remove('is-loading'); });
      return;
    }

    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      changeCart(parseInt(change.getAttribute('data-line'), 10), Math.max(0, parseInt(change.getAttribute('data-qty'), 10)));
    }
  });

  // Aanbevelingen in winkelwagen
  var loadedRecsUrl = null;
  function loadCartRecommendations() {
    if (!theme.cartRecommendations) return;
    var holder = $('[data-cart-recs]');
    if (!holder) return;
    var url = holder.getAttribute('data-url');
    if (!url || url === loadedRecsUrl) return;
    loadedRecsUrl = url;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var inner = parseHTML(html).querySelector('[data-cart-recs-inner]');
        var target = $('[data-cart-recs]');
        if (inner && target && inner.children.length) target.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Productpagina
  ------------------------------------------------------------------ */
  function initProduct(section) {
    var variantsEl = section.querySelector('[data-variants]');
    var picker = section.querySelector('[data-variant-picker]');
    var sectionId = section.getAttribute('data-section-id');
    var baseUrl = section.getAttribute('data-url');
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }

    var fieldsets = picker ? $$('fieldset', picker) : [];

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability() {
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var label = fs.querySelector('label[for="' + input.id + '"]');
          var available = variants.some(function (v) {
            if (!v.available || v.options[index] !== input.value) return false;
            return v.options.every(function (opt, i) {
              return i === index || i > index || opt === selected[i];
            });
          });
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function onChange() {
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-selected-label]');
        if (label) label.textContent = selected[i] || '';
      });
      markAvailability();

      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      var buttonWrap = section.querySelector('[data-update="buy-button"]');
      if (!variant) {
        var button = buttonWrap && buttonWrap.querySelector('button');
        if (button) { button.disabled = true; button.textContent = theme.strings.unavailable; }
        return;
      }

      var idInput = section.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
      }

      if (variant.featured_media) scrollToMedia(variant.featured_media.id);

      fetch(baseUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          $$('[data-update]', section).forEach(function (el) {
            var fresh = doc.querySelector('[data-update="' + el.getAttribute('data-update') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    }

    function scrollToMedia(mediaId) {
      var list = section.querySelector('[data-media-list]');
      var item = section.querySelector('[data-media-id="' + mediaId + '"]');
      if (!list || !item) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        list.prepend(item);
      } else {
        list.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      markAvailability();
    }

    // Mobiele galerij: stippen bijwerken
    var mediaList = section.querySelector('[data-media-list]');
    var dots = $$('.product__dot', section);
    if (mediaList && dots.length) {
      mediaList.addEventListener('scroll', function () {
        var i = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }
  }

  /* ------------------------------------------------------------------
     Tabbladen
  ------------------------------------------------------------------ */
  function initTabs(root) {
    var buttons = $$('[data-tab-button]', root);
    var panels = $$('[data-tab-panel]', root);
    function activate(index) {
      buttons.forEach(function (b, i) { b.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      panels.forEach(function (p, i) { p.hidden = i !== index; });
    }
    buttons.forEach(function (b, i) { b.addEventListener('click', function () { activate(i); }); });
    if (buttons.length) activate(0);
  }

  /* ------------------------------------------------------------------
     Carrousels
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var section = btn.closest('section');
    var track = section && section.querySelector('[data-carousel-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ------------------------------------------------------------------
     Productaanbevelingen (productpagina)
  ------------------------------------------------------------------ */
  function initRecommendations(section) {
    var url = section.getAttribute('data-url');
    if (!url || section.getAttribute('data-loaded')) return;
    section.setAttribute('data-loaded', 'true');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) section.innerHTML = fresh.innerHTML;
        else section.hidden = true;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Collectiepagina: rasterkeuze en meer laden
  ------------------------------------------------------------------ */
  function initCollection(section) {
    var savedDesktop = store('aliy-grid-desktop');
    var savedMobile = store('aliy-grid-mobile');
    if (savedDesktop) setGrid(section, 'desktop', savedDesktop);
    if (savedMobile) setGrid(section, 'mobile', savedMobile);
  }

  function setGrid(section, type, cols) {
    section.style.setProperty(type === 'desktop' ? '--cols-desktop' : '--cols-mobile', cols);
    $$('[data-grid-toggle="' + type + '"]', section).forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-cols') === String(cols));
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-grid-toggle]');
    if (toggle) {
      var section = toggle.closest('[data-collection-section]');
      var type = toggle.getAttribute('data-grid-toggle');
      var cols = toggle.getAttribute('data-cols');
      if (section) setGrid(section, type, cols);
      store('aliy-grid-' + type, cols);
      return;
    }

    var more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      if (more.classList.contains('is-loading')) return;
      more.classList.add('is-loading');
      fetch(more.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var grid = $('[data-product-grid]');
          var newItems = $$('[data-product-grid] > *', doc);
          newItems.forEach(function (item) { grid.appendChild(document.importNode(item, true)); });
          var next = doc.querySelector('[data-load-more]');
          if (next) {
            more.href = next.href;
            more.classList.remove('is-loading');
          } else {
            more.parentNode.remove();
          }
        })
        .catch(function () { window.location.href = more.href; });
    }
  });

  /* ------------------------------------------------------------------
     Land- en taalkeuze
  ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (el && el.form) el.form.submit();
  });

  /* ------------------------------------------------------------------
     Initialisatie (ook opnieuw in de thema-editor)
  ------------------------------------------------------------------ */
  function init(root) {
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-tabs]', root).forEach(initTabs);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    $$('[data-collection-section]', root).forEach(initCollection);
  }

  init(document);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
